import dash_api from '../support/dash_api';
import { ReduxAsyncAction } from '../support/utils';

const ThirdPartyGlobalGet = new ReduxAsyncAction('THIRD_PARTY_GLOBAL_GET');
ThirdPartyGlobalGet.registerRequest(function () {
  return dash_api.get(`/v1/app/third-party-link-global-settings`).then(({ data }) => data);
});

export const loadThirdPartyGlobalSettings = ThirdPartyGlobalGet.request;
export const THIRD_PARTY_GLOBAL_GET = ThirdPartyGlobalGet.constants;

const ThirdPartyGlobalPatch = new ReduxAsyncAction('THIRD_PARTY_GLOBAL_PATCH');
ThirdPartyGlobalPatch.registerRequest(function (body) {
  return dash_api.patch(`/v1/app/third-party-link-global-settings`, body).then(({ data }) => data);
});

export const updateThirdPartyGlobalSettings = ThirdPartyGlobalPatch.request;
export const THIRD_PARTY_GLOBAL_PATCH = ThirdPartyGlobalPatch.constants;
